/**
 * Диапазон дат акции для интерфейса: «28 апреля — 22 июня 2026» (через длинное тире).
 * При разных календарных годах год указывается у обеих дат.
 */
export function formatPromoRangeRu(start, end) {
  if (!start || !end) {
    return '';
  }

  const startDate = new Date(start);
  const endDate = new Date(end);
  if (Number.isNaN(startDate.getTime()) || Number.isNaN(endDate.getTime())) {
    return '';
  }

  const timeZone = 'Europe/Moscow';
  const dayMonth = new Intl.DateTimeFormat('ru-RU', {
    timeZone,
    day: 'numeric',
    month: 'long',
  });
  const yearOnly = new Intl.DateTimeFormat('ru-RU', {
    timeZone,
    year: 'numeric',
  });

  const startYear = yearOnly.format(startDate);
  const endYear = yearOnly.format(endDate);

  if (startYear === endYear) {
    return `${dayMonth.format(startDate)} — ${dayMonth.format(endDate)} ${endYear}`;
  }

  return `${dayMonth.format(startDate)} ${startYear} — ${dayMonth.format(endDate)} ${endYear}`;
}
